import React, { useEffect, useState } from "react";
// import Button from "../../../components/Button";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/Button";
import Spinner from "../../components/PageLoader";
import ResellerTable from "../../components/table/ResellerTable";
import { getResellerDetails } from "../../features/user/userSlice";
import ViewContractModal from "../../components/modal/ViewContractModal";

// import Spinner from "../../../components/PageLoader";

// import Icon from "../../../components/Icon";

// import { getAllStates } from "../../../features/user/userSlice";
// import {
//   getResellerProviderInvitations,
//   getAllResellerCategories,
// } from "../../../features/resellers/resellersSlice";
// import ManageProviderTable from "../../../components/table/ManageProviderTable";
// import ManualPagination from "../../../components/ManualPagination";
// import ProviderDetailSideModal from "../../../components/modals/ProviderDetailSideModal";
// import TerminateContractModal from "../../../components/modals/TerminateContractModal";

const Partner = () => {
  const navigate = useNavigate();

  const { isLoading, resellers } = useSelector((store) => store.user);

  // const [currentPage, setCurrentPage] = useState(0);d
  // const [currentProviders, setCurrentProviders] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getResellerDetails());
  }, []);

  // useEffect(() => {
  //   dispatch(getResellerProviderInvitations({ category: selectedCategory }));
  // }, [selectedCategory]);

  // const PAGE_SIZE = 15;
  // const totalPages = Math.ceil(resellerProviderInvitations?.length / PAGE_SIZE);
  // const startIndex = currentPage * PAGE_SIZE;
  // const endIndex = startIndex + PAGE_SIZE;
  // useEffect(() => {
  //   setCurrentProviders(
  //     resellerProviderInvitations?.slice(startIndex, endIndex)
  //   );
  // }, [currentPage, resellerProviderInvitations]);

  // const handleNext = () => {
  //   if (currentPage < totalPages - 1) {
  //     setCurrentPage(currentPage + 1);
  //   }
  // };

  // const handlePrev = () => {
  //   if (currentPage > 0) {
  //     setCurrentPage(currentPage - 1);
  //   }
  // };

  // const paginationData = {
  //   number: currentPage,
  //   totalPages,
  // };

  // useEffect(() => {
  //   if (selectedCategory) {
  //     setCurrentPage(0);
  //   }
  // }, [selectedCategory]);

  // useEffect(() => {
  //   dispatch(getAllStates());
  // }, []);

  return (
    <>
      <div className="clients mt-[80px] py-[30px] px-[40px]">
        <div className="clients__table">
          <div className="table-container">
            {isLoading ? (
              <Spinner />
            ) : (
              <ResellerTable
                data={resellers}
                setSelectedRow={setSelectedRow}
                setShowModal={setShowModal}
              />
            )}
            {/* {resellerProviderInvitations?.length > 0 && (
            <div className="p-[20px]">
              <ManualPagination
                handleNext={handleNext}
                handlePrev={handlePrev}
                data={paginationData}
                setCurrentPage={setCurrentPage}
              />
            </div>
          )} */}
          </div>
        </div>

        {/*openSideModal && (
				<ClientsDetailSideModal
					openSideModal={openSideModal}
					setOpenSideModal={setOpenSideModal}
					selectedClient={selectedClient}
				/>
			)}*/}
        {/* {openSideModal && (
        <ProviderDetailSideModal
          openSideModal={openSideModal}
          setOpenSideModal={setOpenSideModal}
          selectedRow={selectedRow}
        />
      )} */}
        {/* {terminateContract && (
        <TerminateContractModal
          terminateContract={terminateContract}
          setTerminateContract={setTerminateContract}
        />
      )} */}
      </div>
      {showModal && (
        <ViewContractModal
          closeModal={showModal}
          setCloseModal={setShowModal}
          selectedRow={selectedRow}
        />
      )}
    </>
  );
};

export default Partner;
